import dayjs from 'dayjs';

// A project counts as "ended" when its end date has already passed.
// Archived status wins: an archived project is never treated as ended.
export const isProjectEnded = (project) =>
  Boolean(project?.endAt) &&
  project.status !== 'ARCHIVED' &&
  dayjs(project.endAt).isBefore(dayjs(), 'day');
